const state = {
    department: {
        filter: {
            department_id: "0", 
            year: new Date().getFullYear(),
            month: new Date().getMonth()+1,
            status: "0"
        }
    }

}

const actions = {
    saveDepartmentSearchFilter ({commit}, payload) {
        const { filter } = payload;
        commit('DEPARTMENT_FILTERS', filter);
    }
}

const mutations = {
    DEPARTMENT_FILTERS: (state, response) => {
        state.department.filter = {...response};
    }
}

const getters = {
    filterDTK: state => {
        return state.department.filter;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};